module.exports = __webpack_public_path__ + "media/science.68eba9d1.mp4";